import PropTypes from 'prop-types';
// guards
import AuthGuard from '../guards/AuthGuard';
import EmployeeAuthGuard from '../guards/EmployeeAuthGuard';
import CommonAuthGuard from '../guards/CommonAuthGuard';
// components
import MainLayout from './main';
import DashboardLayout from './dashboard';
import LogoOnlyLayout from './LogoOnlyLayout';
import ScanLayout from './ScanLayout';
import EmployeeLayout from './EmployeeLayout';
import CommonLayout from './CommonLayout';
import { AuthProvider } from 'src/contexts/JwtContext';
import { EmployeeAuthProvider } from 'src/contexts/EmployeeJWTContext';
import EmptyLayout from './EmptyLayout';
import { CommonAuthProvider } from 'src/contexts/CommonJWTContext';
import { CompanyProvider } from 'src/contexts/CompanyContext';
import { PermissionProvider } from 'src/contexts/PermissionContext';
import { FilterProvider } from 'src/contexts/FilterContext';

// ----------------------------------------------------------------------

Layout.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['dashboard', 'empty', 'main', 'logoOnly', 'scanLayout', 'employee', 'common']),
};

export default function Layout({ variant = 'dashboard', children }) {
  if (variant === 'logoOnly') {
    return <LogoOnlyLayout> {children} </LogoOnlyLayout>;
  }

  if (variant === 'empty') {
    return <EmptyLayout> {children} </EmptyLayout>;
  }

  if (variant === 'main') {
    return <MainLayout>{children}</MainLayout>;
  }

  // This Guard only use on ticket tag scan page (Admin, employee login checking)
  if (variant === 'common') {
    return (
      <CommonAuthProvider>
        <CommonAuthGuard>
          <CommonLayout> {children} </CommonLayout>;
        </CommonAuthGuard>
      </CommonAuthProvider>
    );
  }

  if (variant === 'scanLayout') {
    return (
      <AuthProvider>
        <AuthGuard>
          <CompanyProvider>
            <ScanLayout> {children} </ScanLayout>;
          </CompanyProvider>
        </AuthGuard>
      </AuthProvider>
    );
  }

  if (variant === 'employee') {
    return (
      <EmployeeAuthProvider>
        <EmployeeAuthGuard>
          <EmployeeLayout> {children} </EmployeeLayout>;
        </EmployeeAuthGuard>
      </EmployeeAuthProvider>
    );
  }

  return (
    <AuthProvider>
      <AuthGuard>
        <CompanyProvider>
          <PermissionProvider>
            <FilterProvider>
              <DashboardLayout> {children} </DashboardLayout>
            </FilterProvider>
          </PermissionProvider>
        </CompanyProvider>
      </AuthGuard>
    </AuthProvider>
  );
}
